/**
 * Created by daniel.gonzalez on 6/12/15.
 */

'use strict';

const tracking = require('dibs-tracking');
const constants = require('../../../global/mobileAds/mobileAdsConstants');

const trackingObjRender = {
    category: 'app promotion actions',
    label: 'initial load'
};

const trackingObjDownload = {
    category: 'app promotion actions',
    label: 'link click - get the free app',
    noninteraction: 0
};

const trackingObjClose = {
    category: 'app promotion actions',
    label: 'link click - close button'
};

const trackingObjContinueApp = {
    category: 'app promotion actions',
    label: 'link click - continue in app',
    noninteraction: 0
};

const trackingObjMobileSite = {
    category: 'app promotion actions',
    label: 'link click - go to mobile site'
};

const gaActions = {
    [constants.FULLSCREEN_NAME]: 'app interstitial - full screen on second page'
};


function getGaAction(adName) {
    return gaActions[adName];
}

module.exports = {
    /**
     * Clones an obj constant, adds a ga action to the clone based on the ad, and passes the clone to the gtm dataLayer
     * @param trackingObjConstant - the tracking obj constant to be cloned
     */
    trackObj(trackingObjConstant) {
        const adName = this.getAdName();
        const action = getGaAction(adName);
        const trackingObj = Object.assign({action: action}, trackingObjConstant);

        tracking.trackEvent(trackingObj);
    },

    /**
     * tracking that fires when a mobile ad appears
     */
    trackingOnRender() {
        this.trackObj(trackingObjRender);
    },

    /**
     * tracking that fires when user clicks on the button to download the app in the app store
     */
    trackingOnDownload() {
        this.trackObj(trackingObjDownload);
    },

    /**
     * tracking that fires when user clicks on the button to close the ad
     */
    trackingOnClose() {
        this.trackObj(trackingObjClose);
    },

    /**
     * tracking that fires when user clicks on the button to open up the app
     */
    trackingOnContinueToApp() {
        this.trackObj(trackingObjContinueApp);
    },

    /**
     * tracking that fires when user clicks on the button to continue to the mobile site
     */
    trackingObjMobileSite() {
        this.trackObj(trackingObjMobileSite);
    }
};



// WEBPACK FOOTER //
// ./assets/js/global/mobileAds/mixins/trackingMixin.es.js